import { ShieldCheck } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

export function EvidenceCoverageCard({ coverage, isConsultant }) {
  if (!coverage || !(coverage.filled_values > 0)) return null;
  return (
    <Card className="border-slate-200" data-testid="evidence-coverage-card">
      <CardContent className="py-4 flex flex-wrap items-center gap-4">
        <ShieldCheck className="w-5 h-5 text-green-700" aria-hidden="true" />
        <div className="flex-1 min-w-40">
          <p className="text-sm font-semibold text-slate-800">
            Documentazione completa al {coverage.overall}%
          </p>
          <div className="h-2 rounded-full bg-slate-100 mt-1.5">
            <div className="h-full rounded-full bg-green-700" style={{ width: `${coverage.overall}%` }} />
          </div>
        </div>
        {isConsultant && coverage.pillars && (
          <div className="flex gap-3 text-xs text-slate-600" data-testid="coverage-pillars">
            {Object.entries(coverage.pillars).map(([p, v]) => (
              <span key={p}><strong>{p}</strong>: {v === null ? "—" : `${v}%`}</span>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
